module.exports = __webpack_public_path__ + "static/media/taylor-momsen-win.06baf015.jpg";